import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import CustomImage from '../../uielements/Image'
import { theme } from '../../theme/theme'

const NumberWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const ImageWrap = styled.div`
    max-width: 80px;
    display: flex;
    margin: 0 auto;
    justify-content: end;
    min-height: 120px;
`

const Title = styled.div`
    font-size: 4rem;
    font-weight: bold;
    display: block;
    text-align: center;
    color: ${theme.blue};
`

const Text = styled.div`
    text-align: center;
    display: block;
    margin: 0 auto;

    div {
        font-size: 1.2rem;
    }
`

const Number = (props) => {
    return (
        <NumberWrap>
            <ImageWrap>
                <CustomImage obj={props.icon} />
            </ImageWrap>
            <Title>{props.title}</Title>
            <Text>{props.children}</Text>
        </NumberWrap>
    )
}

Number.propTypes = {
    icon: PropTypes.object,
    title: PropTypes.string,
}

Number.defaultProps = {
    icon: 'https://via.placeholder.com/120x120',
    title: 'some title',
}

export default Number
